module.exports = __webpack_public_path__ + "img/kanagawa.915cdf9a.png";